import React, {Component} from 'react';
import {Link, Redirect} from "react-router-dom";
import Timer from "./Timer";
import {config} from "../config";
import axios from "axios";
import * as io from "socket.io-client";
import {withAlert} from "react-alert";
import Loading from "./Loading";

class OTP extends Component{
    constructor(props) {
        super(props);
        this.state = {
            percentage: 1,
            isCorrect : false,
            phone: this.props.phone,
            isLoggedIn: false,
            role: '',
            loading:false,
        };
        this.socket = io('http://socket.irgogps.com');
        this.alert = false;
        this.time = 12000;
        this.verify = this.verify.bind(this);
        this.resetTimer = this.resetTimer.bind(this);
        this.timer = this.timer.bind(this);
    }
    timer() {
        this.time = this.time - 1;
        let percent = (this.time / 12000) * 100;
        this.setState({
            percentage: percent
        });
        if (this.state.percentage === 0) {
            clearInterval(this.interval)
        }
    }

    verify() {
        this.setState({loading: true});
        let data ={
            'mobile' : this.state.phone,
            'otp': document.getElementById('otp').value,
        };

        let req = {
            method: 'post',
            url: config.baseUrl + 'api/v2/auth/otp/verify',
            data: data
        };
        axios(req
        ).then((resp) => {
            if(resp.status===202) {
                this.setState({
                    isCorrect: true,
                });
                let permisions = [];
                for(let item of resp.data.data.roles[0].permissions){
                    permisions.push(item.id);
                }
                permisions.push(0);
                window.localStorage.setItem('prmsn', permisions);
                window.localStorage.setItem('token', resp.data.token);
                window.localStorage.setItem('isLogedin' , true);
                if(resp.data.data.roles[0].slug === "client"){
                    window.localStorage.setItem('role' , resp.data.data.roles[0].slug);
                }else{
                    window.localStorage.setItem('role' , "administrator");
                }
                config.token = resp.data.token;
                this.setState({isLogedIn: true , role: resp.data.data.roles[0].slug , loading:false});
                this.props.alert.success('ورود با موفقیت انجام شد.');
            }
        }).catch(err => {
            this.setState({loading:false});
            this.props.alert.error(err.response.data.errors ? err.response.data.errors[0].message : err.response.data.message)
        });
    }
    resend() {
        this.setState({loading: true});
        let data ={
            'mobile' : this.state.phone,
        };

        let req = {
            method: 'post',
            url: config.baseUrl + 'api/v2/auth/otp/resend',
            data: data
        };
        axios(req
        ).then((resp) => {
            if (resp.status === 200){
                this.setState({loading: false});
                this.props.alert.success('کد تایید دوباره برای شما ارسال شد');
            }
        }).catch(err => {
            this.setState({loading: false});
            this.props.alert.error(err.response.data.errors ? err.response.data.errors[0].message : err.response.data.message)
        });
    }

    resetTimer(){
        clearInterval(this.interval)
        this.time=12000;
        this.interval = setInterval(this.timer, 10);
        this.setState({
            percentage: 100
        });
    }

    componentDidMount(){
        this.interval = setInterval(this.timer, 10);
        this.setState({phone: this.state.phone})
    }
    render() {
        return (
                <div className='left-div col-lg-3 col-md-4 col-sm-6 col-xs-12'>
                    <Loading loading={this.state.loading}/>
                    <div>
                        <h5>تائید شماره موبایل</h5>
                        <p className='blue'>کد ارسال شده به شماره موبایل خود را وارد کنید</p>
                        <span className='line'></span>
                        <form>
                            <div className='input-div '>
                                <h5>کد ارسال شده</h5>
                                <div className='input-group'>
                                    <i className='icon-code inputIcon'></i>
                                    <input id='otp' name='otp' className='input num' placeholder={'77...'}/>
                                </div>
                            </div>
                        </form>
                        {this.state.percentage === 0 ?
                            <div className='resend'>
                                    <button onClick={()=>{
                                        this.resetTimer()
                                        this.resend()
                                    }}><p>ارسال مجدد</p></button>
                            </div> : ''}
                        <div className='button-div blueBtn'>
                            {localStorage.getItem('isLogedin') === 'true' ? <Redirect to='/'/> :''}
                            <button onClick={this.verify}><h5>تایید</h5></button>
                        </div>
                        <div className='button-div pinkBtn'>
                            <Link to={'/login'}><button onClick={this.resetTimer}><h5>انصراف</h5></button></Link>
                        </div>
                        <div style={{textAlign: "center" , padding: " 20px 0"}}>
                            <Timer
                                strokeWidth="5"
                                sqSize="100"
                                percentage={this.state.percentage}
                                time = {this.time}
                            />
                        </div>
                        </div>
                    </div>
                );
    }
}

export default withAlert(OTP);